import { apiSlice } from "../../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdminUnfilteredPipeline: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/admin/loan/pipeline_modified/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetAdminUnfilteredPipelineMutation } = usersApiSlice;
